// The plan-entitlement refusals, named for a practitioner (lib/apiErrors.js
// KNOWN_CODE_MESSAGES): 403 CAPABILITY_NOT_IN_PLAN, 503 CAPABILITY_NOT_BUILT, 409
// PLAN_LIMIT_REACHED. In `common` because extractApiError is called with the common
// translator by every screen that can meet one. The EN strings must stay identical to the
// `en` fallbacks in lib/apiErrors.js.
export default {
  fr: {
    "errors.capabilityNotInPlan": "Cette fonctionnalité n’est pas incluse dans votre forfait. Vous pouvez changer de forfait depuis Abonnement.",
    "errors.capabilityNotBuiltEta": "Cette fonctionnalité arrive bientôt (prévue : {eta}).",
    "errors.capabilityNotBuilt": "Cette fonctionnalité arrive bientôt.",
    "errors.planLimitReached": "Vous avez atteint la limite de votre forfait ({limit}). Changez de forfait depuis Abonnement pour en ajouter.",
    "errors.planLimitReachedNoNumber": "Vous avez atteint la limite de votre forfait. Changez de forfait depuis Abonnement pour en ajouter.",
  },
  en: {
    "errors.capabilityNotInPlan": "This feature is not included in your plan. You can change your plan from Subscription.",
    "errors.capabilityNotBuiltEta": "This feature is coming soon (expected {eta}).",
    "errors.capabilityNotBuilt": "This feature is coming soon.",
    "errors.planLimitReached": "You have reached your plan's limit ({limit}). Change your plan from Subscription to add more.",
    "errors.planLimitReachedNoNumber": "You have reached your plan's limit. Change your plan from Subscription to add more.",
  },
  es: {
    "errors.capabilityNotInPlan": "Esta función no está incluida en tu plan. Puedes cambiar de plan desde Suscripción.",
    "errors.capabilityNotBuiltEta": "Esta función llegará pronto (prevista: {eta}).",
    "errors.capabilityNotBuilt": "Esta función llegará pronto.",
    "errors.planLimitReached": "Has alcanzado el límite de tu plan ({limit}). Cambia de plan desde Suscripción para añadir más.",
    "errors.planLimitReachedNoNumber": "Has alcanzado el límite de tu plan. Cambia de plan desde Suscripción para añadir más.",
  },
};
